export const getBanksByContractType = (banks, contractType) => {
  if (!Array.isArray(banks) || !contractType) return []
  return banks.filter((bank) => bank.contractType === contractType)
}
